import gql from 'graphql-tag';

export const queryBlogPostsLastCreatedAt = gql`
  query blogPostsLastCreatedAt {
    blogPostsLastCreatedAt
  }
`;
export default queryBlogPostsLastCreatedAt;
